import React from 'react';
import {Container, Image} from "react-bootstrap";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import modalManage from "../../reducers/modal-manage";
import {getLocale, getLocaleId} from "../../reducers/locale-selector";

class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClickLang = () => modalManage.show('selectLang');

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.localeId !== this.props.localeId)) this.setState({keyRender: Math.random()});
    }

    render() {
        return <>
                <header className={"Header d-flex align-items-center py-4 w-100 mb-5"}>
                    <Container>
                        <div className={"d-flex Header-Row align-items-center"}>
                            <div className={"my-auto d-flex justify-content-between align-items-center w-100"}>
                                <Image src={this.props.app.logo_negative} className={"Header-Logo"} alt='Logo'/>
                                <span className={"Header-Brand"}>{this.props.t('Pre-shift control')}</span>
                                <div onClick={this.handleClickLang} className="Header-Langs d-flex align-items-center">
                                    <span className="text-uppercase mr-3 font-weight-bold">{this.props.locale.id}</span>
                                    <Image width="32" src={this.props.locale.icon}/>
                                </div>
                            </div>
                        </div>
                    </Container>
                </header>
               </>
    }
}

const mapStateToProps = (store) => {
    return {
        localeId: getLocaleId(store),
        locale: getLocale(store),
        app: store.appState,
    };
};

export default connect(mapStateToProps)(withTranslation()(Header));